import React from 'react';
import { LinearProgress, Box } from '@mui/material';
import { useAppSelector } from '@/store';
import { apiEndpoints } from '@/services/api';

/**
 * Global loading indicator that shows when any RTK Query requests are in progress
 */
export const GlobalLoadingIndicator: React.FC = () => {
  // Get loading state from RTK Query
  const queries = useAppSelector(state => state[apiEndpoints.reducerPath]?.queries || {});
  const mutations = useAppSelector(state => state[apiEndpoints.reducerPath]?.mutations || {});
  
  const isFetching = Object.values(queries).some((query: any) => query?.status === 'pending');
  const isMutating = Object.values(mutations).some((mutation: any) => mutation?.status === 'pending');
  
  const isLoading = isFetching || isMutating;
  
  if (!isLoading) {
    return null;
  }
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
      }}
    >
      <LinearProgress 
        color={isMutating ? 'secondary' : 'primary'}
        sx={{ height: 3 }}
      />
    </Box>
  );
};